import { render, staticRenderFns } from "./BusinessDialog.vue?vue&type=template&id=22180b5c&scoped=true&"
import script from "./BusinessDialog.vue?vue&type=script&lang=js&"
export * from "./BusinessDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22180b5c",
  null
  
)

export default component.exports